import { injectIntl } from "react-intl";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const formatXAxis = (value) => {
  if (value >= 1_000_000) return `$${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `$${(value / 1_000).toFixed(0)}K`;
  return `$${value}`;
};

const getNiceMax = (max) => {
  if (max <= 0) return 1000;
  const magnitude = 10 ** Math.floor(Math.log10(max));
  return Math.ceil(max / magnitude) * magnitude;
};

const RevenueBySegment = ({ data = [] }) => {
  const maxRevenue = getNiceMax(
    Math.max(...data.map((item) => item.revenue), 0)
  );
  const chartHeight = Math.max(data.length * 32 + 40, 120);

  return (
    <div className="SmsAnalyticsChartCard SmsAnalyticsChartCardFull">
      <div className="SmsAnalyticsChartTitle">Revenue by Segment</div>
      <ResponsiveContainer width="100%" height={chartHeight}>
        <BarChart
          data={data}
          layout="vertical"
          margin={{ top: 0, right: 20, left: 0, bottom: 0 }}
          barSize={18}
        >
          <CartesianGrid stroke="#F0F1F5" horizontal={false} />
          <XAxis
            type="number"
            axisLine={false}
            tickLine={false}
            tickFormatter={formatXAxis}
            tick={{ fill: "#6B7280", fontSize: 12, fontFamily: "Chakra Petch" }}
            domain={[0, maxRevenue]}
          />
          <YAxis
            type="category"
            dataKey="name"
            axisLine={false}
            tickLine={false}
            width={110}
            tick={{
              fill: "#6B7280",
              fontSize: 11,
              fontFamily: "Inter",
              fontWeight: 400,
            }}
          />
          <Tooltip
            formatter={(value) => [
              `$${Number(value).toLocaleString()}`,
              "Revenue",
            ]}
            contentStyle={{
              borderRadius: 8,
              border: "1px solid #E5E7F0",
              fontSize: 12,
              fontFamily: "Inter",
            }}
          />
          <Bar dataKey="revenue" fill="#3B82F6" radius={[0, 4, 4, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default injectIntl(RevenueBySegment);
